import {ApiService} from './api.service';
// import {CoreService} from './app-base.service';
// import {AuthenticationService} from '../modules/authentication/authentication.service';
// import {TokenStorage} from './authentication/token-storage.service';
import {BaseService} from './base.service';
import {ConfigService} from './config.service';
import {FormService} from './form.service';
import {CredentialsResolver} from './resolvers.service';
import {DrupalResolve} from '../modules/drupal/drupal.resolve';
import {DrupalService} from '../modules/drupal/drupal.service';
import {WordpressResolve} from '../modules/wordpress/wordpress.resolve';
import {WordpressService} from '../modules/wordpress/wordpress.service';
// import {ModalService} from './modal.service';

export {
    ApiService,
    // CoreService,
    // AuthenticationService,
    // TokenStorage,
    BaseService,
    ConfigService,
    FormService,
    DrupalService,
    WordpressService,
}
export const APP_BASE_LIB_SERVICES: any[] = [
    ApiService,
    // AuthenticationService,
    // TokenStorage,
    BaseService,
    ConfigService,
    FormService,
    // ModalService,
];
export const APP_BASE_SERVICES: any[] = [
    DrupalService,
    WordpressService
];

export const APP_BASE_LIB_RESOLVERS = [
    CredentialsResolver,
    DrupalResolve,
    WordpressResolve,
];
